import { Component, OnInit, Renderer2, ElementRef, ChangeDetectorRef } from '@angular/core';
import { DashboardService } from '@teem/services/dashboard.service';
import { LoaderService } from '@teem/app/core/services/loader.service';
@Component({
	selector: 'app-order-history-table',
	templateUrl: './order-history.component.html',
	styleUrls: ['./order-history.component.scss']
})
export class OrderHistoryComponent implements OnInit {

	params: any = {};
	order_status: any = {};
	filterTypeOrdersHistory: string = 'all';
	isMenuUpwards = false;
	selectedText: string = 'Select an option';
	activeDropdown: HTMLElement | null = null;

	fromDateHistory: string = '';
	toDateHistory: string = '';
	fromAmountHistory: number | null = null;
	toAmountHistory: number | null = null;


	ordersHistory = [];

	filteredOrdersHistory: any[] = [...this.ordersHistory];


	constructor(
		private loaderService:LoaderService,
		private renderer: Renderer2,
		private el: ElementRef,
		private dashboardService: DashboardService,
		private cdr: ChangeDetectorRef,
	) {
		document.addEventListener('click', (event: Event) => {

			const targetElement = event.target as HTMLElement;

			if (!targetElement.closest('.dots_container-rounded')) {

				const optionsMenus = this.el.nativeElement.querySelectorAll('.options-menu');
				optionsMenus.forEach((menu: HTMLElement) => {
					this.renderer.addClass(menu, 'd-none');
				});
			}
		});
	}

	ngOnInit(): void {
		this.getHistoryOrders();
	}

	onDateChangeHistory() {
		if (this.fromDateHistory && this.toDateHistory) {
			this.getHistoryOrders();
		}
	}

	onAmountChangeHistory() {
		if (this.fromAmountHistory !== null && this.toAmountHistory !== null && this.fromAmountHistory <= this.toAmountHistory) {
			this.getHistoryOrders();
		}
	}


	getHistoryOrders() {
		this.loaderService.startLoading();
		this.ordersHistory = [];
		this.filteredOrdersHistory = [];
		const payload = {
			from_date: this.fromDateHistory,
			to_date: this.toDateHistory,
			min_amount: this.fromAmountHistory,
			max_amount: this.toAmountHistory,
			order_status: this.order_status
		};
		this.dashboardService.getHistoryOrders(payload).subscribe((response: any = []) => {
			this.ordersHistory = response;
			this.filteredOrdersHistory = this.ordersHistory;
			this.setFilter(this.filterTypeOrdersHistory);
			this.cdr.detectChanges();
			this.loaderService.stopLoading();
		});
	}

	clearAllFilter() {
		this.fromDateHistory = '';
		this.toDateHistory = '';
		this.fromAmountHistory = null;
		this.toAmountHistory = null;
		this.order_status = '';
		this.selectedText = 'Select an option';
		this.getHistoryOrders();
	}

	toggleMenu(event: MouseEvent, row: any, index: number): void {
		event.stopPropagation();
		
		// Скролл вниз на 116px
		const scrollContainer = (event.target as HTMLElement).closest('.order_history_table');
		if (scrollContainer) {
			scrollContainer.scrollTop += 116;
		}
		
		// Store the previous state before closing all menus
		const wasVisible = row.menuVisible;
	
		// Close all menus
		this.ordersHistory.forEach((r) => (r.menuVisible = false));
	
		// Toggle only if it was not already open
		row.menuVisible = !wasVisible;
	
		// Check if the menu should be placed upwards
		const totalRows = this.ordersHistory.length;
		this.isMenuUpwards = index >= totalRows - 2;
	}

	toggleFilters(event: Event): void {
		const selectedElement = event.target as HTMLElement;
		console.log('selectedElement', selectedElement)
		const filterElementFather = selectedElement.closest('.order_history_block');
		const filterElement = filterElementFather.querySelector('.filters_expanded');
		console.log('filterElementFather', filterElementFather)
		console.log('filterElement', filterElement)

		if (filterElement) {
			if (filterElement.classList.contains('visible')) {
				this.renderer.removeClass(filterElement, 'visible');
			} else {
				this.renderer.addClass(filterElement, 'visible');
			}
		}
	}

	setFilter(type: string) {
		this.filterTypeOrdersHistory = type;
		if (type === 'all') {
			this.filteredOrdersHistory = this.ordersHistory;
		} else {
			this.filteredOrdersHistory = this.ordersHistory.filter(order =>
				type === 'pick-up' ? order.pickup_date !== null : order.pickup_date === null
			);
		}
	}

	selectItem(event: Event): void {
		const selectedElement = event.target as HTMLElement;
		this.selectedText = selectedElement.innerText.trim();
		this.order_status = this.selectedText;

		const activeDropdowns = document.querySelectorAll('.custom_select.active');
		activeDropdowns.forEach((dropdown) => {
			this.renderer.removeClass(dropdown, 'active');
			const dropdownMenu = dropdown.querySelector('.custom_select-content') as HTMLElement;
			if (dropdownMenu) {
				this.renderer.setStyle(dropdownMenu, 'display', 'none');
			}
		});

		this.activeDropdown = null;
		this.getHistoryOrders();
	}

	toggleDropdown(event: Event): void {
		const button = event.target as HTMLElement;
		const dropdownContainer = button.closest('.custom_select');
		const dropdownMenu = dropdownContainer.querySelector('.custom_select-content');
		const allDropdowns = document.querySelectorAll('.custom_select-content');
		const allContainers = document.querySelectorAll('.custom_select');

		allDropdowns.forEach((dropdown) => {
			if (dropdown !== dropdownMenu) {
				this.renderer.setStyle(dropdown, 'display', 'none');
			}
		});

		allContainers.forEach((container) => {
			if (container !== dropdownContainer) {
				this.renderer.removeClass(container, 'active');
			}
		});

		const isDropdownVisible = dropdownMenu.getAttribute('style') === 'display: block;';

		this.renderer.setStyle(dropdownMenu, 'display', isDropdownVisible ? 'none' : 'block');

		if (isDropdownVisible) {
			this.renderer.removeClass(dropdownContainer, 'active');
		} else {
			this.renderer.addClass(dropdownContainer, 'active');
		}
	}

	trackByInvoice(index: number, order: any) {
		return order.invoiceNum;
	}
}
